import { PageTitle, PageNumber, Question, Container, PolicyLink, Policy, Required } from './surveyModalStyled';
import React from 'react';
import { surveyDataType } from '../surveyData';
import { SurveyRadioQuestion } from './SurveyRadioQuestion';
import { Space, Button } from '@gr-monorepo/common/ui';
import { ReactComponent as FinishIcon } from '../assets/finish.svg';
import { Row } from '../VectorSurveyStyled';
import Input from '@gr-monorepo/common/ui/Input';
import { useClickStreamContext } from '../../../../shared/ClickStream';

export const QuestionsPage = ({
  ...props
}: {
  page: number;
  firstQuestion: surveyDataType;
  firstAnswerValue: string;
  setFirstAnswerValue: (value: string) => void;
  secondQuestion: surveyDataType;
  secondAnswerValue: string;
  setSecondAnswerValue: (value: string) => void;
  handleNext: () => void;
}) => {
  const canContinue = props.firstAnswerValue && props.secondAnswerValue;

  return (
    <Container style={{ height: '580px' }}>
      <PageTitle>Опрос о возможностях Учи.ру для ДОУ</PageTitle>
      <Space size={8} axis={'vertical'} />
      <PageNumber>{`Страница ${props.page} из 4`}</PageNumber>
      <Space size={24} axis={'vertical'} />
      <SurveyRadioQuestion
        question={props.firstQuestion.question}
        answers={props.firstQuestion.answers}
        setAnswer={props.setFirstAnswerValue}
        answerValue={props.firstAnswerValue}
      />
      <Space size={16} style={{ flex: 1 }} axis={'vertical'} />
      <SurveyRadioQuestion
        question={props.secondQuestion.question}
        answers={props.secondQuestion.answers}
        setAnswer={props.setSecondAnswerValue}
        answerValue={props.secondAnswerValue}
      />
      <Space size={16} style={{ flex: 1 }} axis="vertical" />{' '}
      <Button
        color={'violet'}
        isDisabled={!canContinue}
        colorDisabled={'#DBB2FF'}
        style={{ width: '260px', alignSelf: 'center' }}
        onClick={() => props.handleNext()}
      >
        продолжить
      </Button>
    </Container>
  );
};

export const FinishPage = () => {
  return (
    <Container style={{ height: '500px', justifyContent: 'center' }}>
      <Row>
        <FinishIcon />
      </Row>
      <Space size={28} axis={'vertical'} />
      <Question style={{ alignSelf: 'center' }}>Благодарим за прохождение опроса!</Question>
    </Container>
  );
};

export const ContactsPage = ({
  ...props
}: {
  page: number;
  name: string;
  nameError: string | null;
  setName: (value: string) => void;
  job: string;
  jobError: string | null;
  setJob: (value: string) => void;
  email: string;
  emailError: string | null;
  setEmail: (value: string) => void;
  phone: string;
  phoneError: string | null;
  setPhone: (value: string) => void;
  handleNext: () => void;
  logPrefix: string;
}) => {
  const { logPageEvent } = useClickStreamContext();
  return (
    <Container>
      <PageTitle>Опрос о возможностях Учи.ру для ДОУ</PageTitle>
      <Space size={8} axis={'vertical'} />
      <PageNumber>{`Страница ${props.page} из 4`}</PageNumber>
      <Space size={24} axis={'vertical'} />
      <Question>
        Чтобы подробнее обсудить возможности Учи.ру для дошкольных образовательных учреждений муниципалитета,
        пожалуйста, оставьте нам свои данные.
      </Question>
      <Space size={16} axis={'vertical'} />
      Ф. И. О. *
      <Space size={8} axis="vertical" />
      <Input
        value={props.name}
        onChange={props.setName}
        error={!!props.nameError}
        errorText={props.nameError || ''}
        placeholder="Иванов Иван Иванович"
        onBlur={() => {}}
        style={{ borderColor: !!props.nameError ? '#FF6170' : 'rgba(9, 21, 38, 0.6)' }}
      />
      <Space size={16} axis="vertical" />
      Должность*
      <Space size={8} axis="vertical" />
      <Input
        value={props.job}
        onChange={props.setJob}
        error={!!props.jobError}
        errorText={props.jobError || ''}
        placeholder="Начальник управления образования"
        style={{ borderColor: !!props.jobError ? '#FF6170' : 'rgba(9, 21, 38, 0.6)' }}
      />
      <Space size={16} axis="vertical" />
      Контакты*
      <Space size={8} axis="vertical" />
      <Row>
        <Input
          value={props.email}
          onChange={props.setEmail}
          error={!!props.emailError}
          errorText={props.emailError || ''}
          placeholder="email@pochta.ru"
          style={{ width: '100%', borderColor: !!props.emailError ? '#FF6170' : 'rgba(9, 21, 38, 0.6)' }}
        />
        <Space size={16} />
        или
        <Space size={16} />
        <Input
          value={props.phone}
          onChange={props.setPhone}
          error={!!props.phoneError}
          errorText={props.phoneError || ''}
          placeholder="+7 (XXX) XXX-XX-XX"
          style={{ width: '100%', borderColor: !!props.phoneError ? '#FF6170' : 'rgba(9, 21, 38, 0.6)' }}
          mask="+7 (000) 000-00-00"
        />
      </Row>
      <Space size={12} axis={'vertical'} />
      <Required>Поля, помеченные *, обязательны для заполнения</Required>
      <Space size={12} axis={'vertical'} />
      <Policy>
        Нажимая «Отправить», вы соглашаетесь с{' '}
        <PolicyLink
          href="https://uchi.ru/privacy"
          target="_blank"
          onClick={() =>
            logPageEvent({
              eventType: `${props.logPrefix}_open_privacy`,
              eventInfo: `Нажал открыть политику обработки ПД в опросе по вектору`,
            })
          }
        >
          политикой обработки персональных данных
        </PolicyLink>{' '}
      </Policy>
      <Space size={20} axis={'vertical'} />
      <Button
        color={'violet'}
        colorDisabled={'#DBB2FF'}
        style={{ width: '260px', alignSelf: 'center' }}
        onClick={props.handleNext}
      >
        Отправить
      </Button>
    </Container>
  );
};
